import React, { useState, useEffect } from "react";
import {
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
} from "recharts";
import api from "../../utils/api";

const GeoDetailChart = ({ queryParams }) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [country, setCountry] = useState("US");

  useEffect(() => {
    setLoading(true);
    api
      .get(`/api/analytics/geo-detail?country=${country}&${queryParams}`)
      .then((res) => setData(res.data))
      .catch(console.error)
      .finally(() => setLoading(false));
  }, [queryParams, country]);

  if (loading) {
    return <div className="text-center py-4"><div className="spinner-border spinner-border-sm" role="status" /></div>;
  }

  if (!data) return <p className="text-muted text-center">No data</p>;

  return (
    <div>
      <div className="d-flex gap-2 mb-3">
        {["US", "CA", "MX", "PR"].map((c) => (
          <button key={c} className={`btn btn-sm ${country === c ? "btn-tl-primary" : "btn-outline-secondary"}`} style={{ borderRadius: "8px" }} onClick={() => setCountry(c)}>
            {c}
          </button>
        ))}
      </div>

      <div className="row">
        <div className="col-md-6">
          <h6 style={{ fontSize: "12px", fontWeight: 600, textTransform: "uppercase", color: "#94a3b8", marginBottom: "8px" }}>
            Top Regions ({data.regions.length})
          </h6>
          <ResponsiveContainer width="100%" height={Math.max(200, data.regions.slice(0, 20).length * 28)}>
            <BarChart data={data.regions.slice(0, 20)} layout="vertical" margin={{ left: 10 }}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis type="number" />
              <YAxis dataKey="name" type="category" width={100} tick={{ fontSize: 11 }} />
              <Tooltip />
              <Bar dataKey="count" fill="#6366f1" radius={[0, 4, 4, 0]} />
            </BarChart>
          </ResponsiveContainer>
        </div>
        <div className="col-md-6">
          <h6 style={{ fontSize: "12px", fontWeight: 600, textTransform: "uppercase", color: "#94a3b8", marginBottom: "8px" }}>
            Top Cities ({data.cities.length})
          </h6>
          <div style={{ maxHeight: "500px", overflow: "auto" }}>
            <table className="tl-table" style={{ fontSize: "13px" }}>
              <thead style={{ position: "sticky", top: 0, background: "#fff" }}>
                <tr><th>City</th><th>State/Region</th><th style={{ textAlign: "right" }}>Scans</th></tr>
              </thead>
              <tbody>
                {data.cities.map((c, i) => (
                  <tr key={i} style={{ cursor: "default" }}>
                    <td style={{ fontWeight: 500 }}>{c.city}</td>
                    <td className="text-muted">{c.region}</td>
                    <td style={{ textAlign: "right", fontWeight: 600 }}>{c.count.toLocaleString()}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GeoDetailChart;
